import React from 'react';
import axios from "../../../../containers/api";
import {Alert, Button, FormGroup, Input, Label} from "reactstrap";
import {showCatchError, toEnglishNumbers} from "../../../../helpers/Utils";

class AgentSazman extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            agentId: this.props.agentId,
            agentWSUserName: "",
            agentWSPassword: "",
            agentCompanyCode: "",
            agent: [],
            agentWSCodesId: null,
            agentWSActive: false,
            errors: []
        }
    }

    componentDidMount() {
        this.GetAgentWSCode();
    }

    GetAgentWSCode = () => {
        this.props.showSpinner();
        axios.get('api/AgentWSCodeApi/GetAgentWSCode?agentId=' + this.state.agentId)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data !== null) {
                    this.setState({
                        agentWSUserName: res.data.agentWSUserName,
                        agentWSPassword: res.data.agentWSPassword,
                        agentCompanyCode: res.data.agentCompanyCode,
                        agent: res.data.agent,
                        agentWSCodesId: res.data.id,
                        agentWSActive: res.data.agentWSActive
                    });
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    validateInputData = () => {
        this.props.closeSweetAlert();
        let error = [];
        if (this.state.agentWSUserName === null || this.state.agentWSUserName === '' || this.state.agentWSUserName === undefined
            || this.state.agentWSPassword === null || this.state.agentWSPassword === '' || this.state.agentWSPassword === undefined) {
            error.push('نام کاربری و رمز عبور را وارد کنید.');
        }

        this.setState({ errors: error });
        if (error.length === 0) {
            this.SaveAgentWSCode();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };

    SaveAgentWSCode = () => {
        const model = {
            AgentId: this.state.agentId,
            AgentWSUserName: toEnglishNumbers(this.state.agentWSUserName),
            AgentWSPassword: toEnglishNumbers(this.state.agentWSPassword),
            AgentCompanyCode: toEnglishNumbers(this.state.agentCompanyCode),
            Agent: this.state.agent !== null ? this.state.agent : [],
            Id: this.state.agentWSCodesId !== null ? this.state.agentWSCodesId : null,
            AgentWSActive: this.state.agentWSActive !== null ? this.state.agentWSActive : false
        }

        this.props.showSpinner();
        axios.post('api/AgentWSCodeApi/SaveAgentWSCode', model)
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert(res.data, 'success');
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    render() {
        return (
            <div className="d-flex flex-column w-100">
                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>نام کاربری</Label>
                        <Input value={this.state.agentWSUserName} maxLength={100}
                               onChange={(e) => this.setState({agentWSUserName: e.target.value})}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>رمز عبور</Label>
                        <Input value={this.state.agentWSPassword} maxLength={100}
                               onChange={(e) => this.setState({agentWSPassword: e.target.value})}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>کد نمایندگی</Label>
                        <Input value={this.state.agentCompanyCode} maxLength={20}
                               onChange={(e) => this.setState({agentCompanyCode: e.target.value})}/>
                    </FormGroup>
                </div>

                {this.state.errors.length === 0 ?
                    null
                    :
                    <div>
                        {(this.state.errors.map((error, i) => {
                            return (
                                <Alert color="danger" key={i}>{error}</Alert>
                            )
                        }))}
                    </div>
                }

                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="text-center">
                        <Button color="primary" className="btn-lg mx-2" disabled={this.state.luckButton}
                                onClick={() => this.props.showSweetAlert("آیا از صحت اطلاعات وارد شده اطمینان دارید؟", "", "warning", this.validateInputData)}>
                            ثبت
                        </Button>
                    </FormGroup>
                </div>

            </div>
        );
    }
}

export default AgentSazman;